import React from "react";
import {FormattedMessage} from "react-intl";
import styles from "./index.module.scss";

function OneBtnPopup({title, subtitle, confirmBtn, confirmAction, dismiss}) {
  const onClickConfirm = () => {
    confirmAction && confirmAction();
    dismiss();
  };

  return (
    <div className={styles.one_btn_popup}>
      <h3 className={styles.title}>
        {title ? (
          title
        ) : (
          <FormattedMessage id="ID_POST_DECLARE_SUCSESS_TITLE" />
        )}
      </h3>
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      <div className={styles.button_box}>
        <button type="button" onClick={onClickConfirm}>
          {confirmBtn ? (
            confirmBtn
          ) : (
            <FormattedMessage id="ID_POPUP_BTN_CONFIRM" />
          )}
        </button>
      </div>
    </div>
  );
}

export default OneBtnPopup;
